import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const data = [
  { name: "Maintenance", value: 4 },
  { name: "Repairs", value: 1 },
  { name: "Others", value: 0 },
];

const COLORS = ["#1970E6", "#E41B1B",];

const TotalOrdersByServices = () => {
  return (
      <ResponsiveContainer width="100%" height={250}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={100}
            innerRadius={40}
            fill="#8884d8"
            label={({ name }) => `${name}`} // only show value on the slice
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip
            formatter={(value) => `${value}`}
            labelFormatter={(label) => `${label}`}
          />
          {/* Removed the <Legend /> */}
        </PieChart>
      </ResponsiveContainer>
  );
};

export default TotalOrdersByServices;
